document.addEventListener('DOMContentLoaded', ()=>{
    const siteHeaderHeight = document.querySelector('#shopify-section-header').clientHeight;
    document.querySelector('predictive-search-drawer.drawer').style.height = `${siteHeaderHeight}px`;

	// pdp contact form modal
  	let pdpPopTrigger = document.querySelector('#ContactUs');
    let pdpPopTarget = document.querySelector('#contactus-popup');
    let pdpPopClose = document.querySelector('#contactus-popup .modal__close-button');
	if(pdpPopTrigger){
      pdpPopTrigger.addEventListener('click', () => {
        pdpPopTarget.classList.add('modal-active');
      })
	}
    if(pdpPopClose){
      pdpPopClose.addEventListener('click', () => {
          pdpPopTarget.classList.remove('modal-active');
      });
	}
       
	// mobile searchanise filter layout change
	const mobileFilterLayout = setInterval( ()=> {
	  let targetEle = document.querySelector('#snize-modal-mobile-filters-dialog .snize-modal-content');                                           	                                   
      if(targetEle){
        let mobFilterArray = [
          document.querySelector('#snize-modal-mobile-filters-dialog #snize_product_filter_header_mobile_sort'),
          document.querySelector('#snize-modal-mobile-filters-dialog #snize_product_filter_mobile_sort'),
          document.querySelector('#snize-modal-mobile-filters-dialog .snize-product-filters-buttons-container')
        ]
        mobFilterArray.forEach(ele => {
          targetEle.appendChild(ele)
        });
      }
    },100)
	
	
});
